import { Language, LocalStorageKey } from "../data/constants";
import { TranslationKey } from "../translations/TranslationKey";
import { ExamTemplateIndex } from "./Exam";

export interface ModuleIndex {
  id: string;
  nameDE: string;
  nameEN: string;
  nameFR: string;
  nameIT: string;
  moduleType: ModuleType;
  certificateValidity: ModuleCertificateValidity;
  status: ModuleStatus;
}

export interface ModuleViewModel {
  id: string;
  nameDE: string;
  nameEN: string;
  nameFR: string;
  nameIT: string;
  moduleType: ModuleType;
  certificateValidity: ModuleCertificateValidity;
  status: ModuleStatus;
  exams: ExamTemplateIndex[];
  allowOptions: boolean;
  allowDocumentUpload: boolean;
  verificationRequired: boolean;
  price?: number;
  abacusNumber: string;
  gradingRule?: ModuleGradingRules;
  allowRegistrationOnlyOnce: boolean;
}

export enum ModuleGradingRules {
  AverageGrade = "AverageGrade",
  AllExams = "AllExams",
}

export const ModuleGradingRulesTranslationKey: {
  [moduleGradingRules in ModuleGradingRules]: TranslationKey;
} = {
  [ModuleGradingRules.AverageGrade]: "module.field.gradingRules.averageGrade",
  [ModuleGradingRules.AllExams]: "module.field.gradingRules.allExams",
};

export enum ModuleStatus {
  Draft = "Draft",
  Published = "Published",
  Archived = "Archived",
}

export enum ModuleCertificateValidity {
  Unlimited = "Unlimited",
  FiveYears = "FiveYears",
  OneYear = "OneYear",
}

export const ModuleStateTranslationKey: {
  [moduleStatus in ModuleStatus]: TranslationKey;
} = {
  [ModuleStatus.Draft]: "common.status.draft",
  [ModuleStatus.Published]: "common.status.published",
  [ModuleStatus.Archived]: "common.status.archived",
};

export const ModuleCertificateValidityTranslationKey: {
  [moduleCertificationValidation in ModuleCertificateValidity]: TranslationKey;
} = {
  [ModuleCertificateValidity.Unlimited]: "module.field.certificateValidity.Unlimited",
  [ModuleCertificateValidity.FiveYears]: "module.field.certificateValidity.FiveYears",
  [ModuleCertificateValidity.OneYear]: "module.field.certificateValidity.OneYear",
};

export enum ModuleType {
  Mandatory = "Mandatory",
  ProcessModule = "ProcessModule",
  OptionalModule = "OptionalModule",
}

export const ModuleTypeTranslationKey: {
  [moduleType in ModuleType]: TranslationKey;
} = {
  [ModuleType.Mandatory]: "module.field.moduleType.mandatory",
  [ModuleType.ProcessModule]: "module.field.moduleType.processModule",
  [ModuleType.OptionalModule]: "module.field.moduleType.optionalModule",
};

export interface RequiredModule {
  isNameDEEmpty: boolean;
  isNameFREmpty: boolean;
  isNameENEmpty: boolean;
  isNameITEmpty: boolean;
  isPriceEmpty: boolean;
  isGradingRuleEmpty: boolean;
}

export const GetLocalizedName = (module: ModuleIndex): string => {
  const language = localStorage.getItem(LocalStorageKey.LastSelectedLanguageKey);

  switch (language) {
    case Language.EN:
      return module.nameEN;
    case Language.FR:
      return module.nameFR;
    case Language.IT:
      return module.nameIT;
  }

  return module.nameDE;
};
